<template>
  <div class="ct-form-box">
    <div class="form-title">
      <h6>
          {{ $t('Contributors') }} <small v-if="$i18n.locale!=='en'">Contributors</small>
      </h6>
      <button type="button" class="ct-help-box" v-on:click="showHelpMessage('contributors')">
          <span class="ct-tip-icon"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
            <path fill="#0c68f8" d="M6304.806 2008.056a6 6 0 1 0 6 6 6 6 0 0 0-6-6zm.425 9.021a.7.7 0 0 1-.449.151.71.71 0 0 1-.458-.151.75.75 0 0 1 0-1 .724.724 0 0 1 .458-.147.711.711 0 0 1 .449.147.749.749 0 0 1 0 1zm1.462-3.945a1.545 1.545 0 0 1-.336.475 6.453 6.453 0 0 1-.533.462 3.483 3.483 0 0 0-.4.344.837.837 0 0 0-.185.282 1 1 0 0 0-.05.34v.21h-.9v-.277a1.484 1.484 0 0 1 .164-.731 2.212 2.212 0 0 1 .584-.622 3.728 3.728 0 0 0 .593-.529.8.8 0 0 0 .172-.521.573.573 0 0 0-.223-.487 1.035 1.035 0 0 0-.634-.168 2.275 2.275 0 0 0-.706.109 4.853 4.853 0 0 0-.672.277l-.378-.79a4.134 4.134 0 0 1 .84-.34 3.62 3.62 0 0 1 1-.13 1.917 1.917 0 0 1 1.31.407 1.358 1.358 0 0 1 .462 1.071 1.516 1.516 0 0 1-.108.618z" transform="translate(-6298.806 -2008.056)"/>
          </svg></span>
      </button>
    </div>
    <div class="ct-form wv-form-add" v-for="(val, idx) in contributors">
      <ul class="wv-row wv-row-cols-md-4">
        <li class="wv-col wv-col-3">
          <div class="wv-dropdown">
            <button :id="'drop-'+idx" v-on:click="showDropDown($event)" class="wv-dropbtn btn-contributor">
              {{ $t(val.contributor)}}
            </button>

            <div id="wv-myDropdown" class="wv-dropdown-content">
              <button :id="'author-'+idx" :class="{selected:val.contributor == 'author'}" class="wv-dropmenu" v-on:click="selectOption(idx, 'author', $event)">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                  <path fill="none" d="M0 0H20V20H0z"/>
                  <path fill="#333" d="M9.046 15.825l-2.932-2.932-1 .992 3.931 3.931 8.438-8.438-.992-.992z" transform="translate(-2.115 -3.385)"/>
                </svg>
                {{ $t('author') }}
              </button>
              <button :id="'editor-'+idx" :class="{selected:val.contributor == 'editor'}" class="wv-dropmenu" v-on:click="selectOption(idx, 'editor', $event)">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                  <path fill="none" d="M0 0H20V20H0z"/>
                  <path fill="#333" d="M9.046 15.825l-2.932-2.932-1 .992 3.931 3.931 8.438-8.438-.992-.992z" transform="translate(-2.115 -3.385)"/>
                </svg>
                {{ $t('editor') }}
              </button>
              <button :id="'translator-'+idx" :class="{selected:val.contributor == 'translator'}" class="wv-dropmenu" v-on:click="selectOption(idx, 'translator', $event)">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                  <path fill="none" d="M0 0H20V20H0z"/>
                  <path fill="#333" d="M9.046 15.825l-2.932-2.932-1 .992 3.931 3.931 8.438-8.438-.992-.992z" transform="translate(-2.115 -3.385)"/>
                </svg>
                {{ $t('translator') }}
              </button>
            </div>
          </div>
        </li>

        <!-- First Name -->
        <li class="wv-col wv-col-3">
          <div class="wv-form-box">
            <input v-model="val.given" type="text" class="wv-form-control" :placeholder="$t('First Name')" @input="inputContributors">
            <svg class="wv-form-fail-ic" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
              <path fill="#f80003" d="M10 20a10 10 0 1 1 10-10 10.011 10.011 0 0 1-10 10zm0-7.268a1.383 1.383 0 1 0 1.383 1.383A1.385 1.385 0 0 0 10 12.732zM9.191 5a.415.415 0 0 0-.414.437L9 11.325a.414.414 0 0 0 .414.395h1.148a.414.414 0 0 0 .414-.395l.246-5.889A.415.415 0 0 0 10.809 5z"></path>
            </svg>
          </div>
        </li>

        <!-- Middle Name -->
        <li class="wv-col wv-col-3">
          <div class="wv-form-box">
            <input v-model="val.middle" type="text" class="wv-form-control" :placeholder="$t('Middle')" @input="inputContributors">
            <svg class="wv-form-fail-ic" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
              <path fill="#f80003" d="M10 20a10 10 0 1 1 10-10 10.011 10.011 0 0 1-10 10zm0-7.268a1.383 1.383 0 1 0 1.383 1.383A1.385 1.385 0 0 0 10 12.732zM9.191 5a.415.415 0 0 0-.414.437L9 11.325a.414.414 0 0 0 .414.395h1.148a.414.414 0 0 0 .414-.395l.246-5.889A.415.415 0 0 0 10.809 5z"></path>
            </svg>
          </div>
        </li>

        <!-- Last Name -->
        <li class="wv-col wv-col-3">
          <div class="wv-form-box">
            <input v-model="val.family" type="text" class="wv-form-control" :placeholder="$t('Last Name')" @input="inputContributors">
            <svg class="wv-form-fail-ic" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
              <path fill="#f80003" d="M10 20a10 10 0 1 1 10-10 10.011 10.011 0 0 1-10 10zm0-7.268a1.383 1.383 0 1 0 1.383 1.383A1.385 1.385 0 0 0 10 12.732zM9.191 5a.415.415 0 0 0-.414.437L9 11.325a.414.414 0 0 0 .414.395h1.148a.414.414 0 0 0 .414-.395l.246-5.889A.415.415 0 0 0 10.809 5z"></path>
            </svg>
          </div>
        </li>
      </ul>

      <!-- remove btn -->
      <button class="wv-form-icon" v-on:click="removeContributor(idx)" v-show="idx !== 0">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <rect width="24" height="24" fill="#ffe5e5" rx="4"></rect>
          <path fill="#f80003" d="M0 0H2V14H0z" transform="rotate(90 4 15)"></path>
        </svg>
      </button>

      <!-- add btn -->
      <button class="wv-form-icon" v-on:click="addContributor"  v-show="idx === (contributors.length-1)">
        <svg xmlns="http://www.w3.org/2000/svg" id="btn_plus" width="24" height="24" viewBox="0 0 24 24">
          <g id="icon_plus">
            <rect id="" width="24" height="24" fill="#eaeff6" rx="4"></rect>
            <path id="" d="M0 0H2V14H0z" class="cls-2" transform="translate(11 5)"></path>
            <path id="" d="M0 0H2V14H0z" class="cls-2" transform="rotate(90 4 15)"></path>
          </g>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
    // Contributor 생성
    import { BIcon, BIconTrashFill, BIconPlus } from 'bootstrap-vue'
    import cloneDeep from "lodash/cloneDeep";

    export default {
        name: "FormContributor",
        components: {
            BIcon,
            BIconTrashFill,
            BIconPlus
        },

        props: [
            'citeStyle'
        ],

        data: function () {
            return {
                contributors: [
                    {contributor : 'author', given : '', middle : '', family : ''}
                ],
                'cite_style' : this.citeStyle,
            }
        },

        methods: {
            inputContributors(){
                this.$emit('input', this.contributors);
            },
            showDropDown(event){
              //show 제거
              Array.from(document.querySelectorAll('.wv-dropdown-content')).forEach(function(el) {
                  el.classList.remove('show');
              });

              //타켓 찾아서 show class 추가
              let targetId = event.currentTarget.id;
              document.getElementById(targetId).nextElementSibling.classList.toggle("show");
              this.inputContributors();
            },
            selectOption(idx, option, event){
                this.contributors[idx].contributor = option
                this.inputContributors();
            },
            addContributor () {
                this.contributors.push({contributor : 'author', given : '', middle : '', family : ''});
            },
            removeContributor (idx) {
                if( idx === 0 ) return false;
                this.contributors.splice(idx, 1);
            },
            showHelpMessage (idx) {
                this.$parent.showHelpMessage(idx);
            }
        },
        watch: {
            citeStyle: function (val) {
                this.cite_style = String(val);
            },
        },
        mounted() {
          window.onclick = function(event) {
            var matches = event.target.matches ? event.target.matches('.wv-dropbtn') : event.target.msMatchesSelector('.wv-dropbtn');
            if (!matches) {
              let dropdowns = document.getElementsByClassName("wv-dropdown-content");
              let i;
              for (i = 0; i < dropdowns.length; i++) {
                let openDropdown = dropdowns[i];
                if (openDropdown.classList.contains('show')) {
                  openDropdown.classList.remove('show');
                  this.selected = undefined;
                }
              }
            }
          }
        }
    }
</script>

<style scoped>
    .ct-form-box{
        margin-bottom: 1.25em;
    }
    .form-contributor-container {
        margin-bottom: 1.25em;
    }

    /* table-border */
    .contributor-table {
        width: 100%;
        margin-bottom: 1em;
        font-size: .85em;
        color: #212529;
        border: 1px solid #dee2e6;
        border-collapse: collapse;
    }

    .contributor-table thead th {
        vertical-align: bottom;
        border-bottom: 2px solid #dee2e6;
    }

    .contributor-table td, .contributor-table th {
        padding: .75em;
        vertical-align: top;
        border-top: 1px solid #dee2e6;
        color: #212529;
        background:inherit;
        height: auto;
    }

    .contributor-table thead td, .contributor-table thead th {
        border-bottom-width: 2px;
    }

    .contributor-table thead th {
        vertical-align: bottom;
        border-bottom: 2px solid #dee2e6;
    }

    .contributor-table th {
        font-weight: bold
    }

    .contributor-table td, .contributor-table th {
        border: 1px solid #dee2e6;
    }

    .contributor {
        margin-bottom:.25em;
    }

    .wv-dropdown-content .wv-dropmenu{
        border: 0;
        background: none;
        width: 100%;
        text-align: left;
    }
    .btn-contributor{
        text-transform: capitalize;
    }


</style>



// WEBPACK FOOTER //
// src/components/FormContributor.vue